/**
 * an wrapper around document tree walker with extra features
 */
export class Walker {
    constructor(root) {
        this.ended = false;
        this.walker = document.createTreeWalker(root, NodeFilter.SHOW_ALL);
    }
    step() {
        if (this.walker.firstChild()) {
            return;
        }
        this.skip();
    }
    /**
     * skip whole subtree
     */
    skip() {
        if (this.walker.nextSibling()) {
            return;
        }
        while (this.walker.parentNode()) {
            if (this.walker.nextSibling()) {
                return;
            }
        }
        this.ended = true;
    }
    /**
     * visit the subtree while ignoring depth info
     * @param visit
     */
    sprint(visit) {
        this.shadowSprint(visit, this.walker);
        this.ended = true;
    }
    shadowSprint(visit, walker) {
        do {
            visit(walker.currentNode);
            if (walker.currentNode.shadowRoot) {
                this.shadowSprint(visit, document.createTreeWalker(walker.currentNode.shadowRoot, NodeFilter.SHOW_ALL));
            }
        } while (!this.ended && walker.nextNode());
    }
}
//# sourceMappingURL=walker.js.map